import { useMemo, useState } from "react";
import { Shape } from "../../math/Shape";
import { getLineWidth } from "./util";
import { Set } from "immutable";
const BASE_HIGHLIGHTED_LINE_WIDTH = 4;
const createPolygonLayerData = ({ contours, lineWidth, }) => ({
    id: 'highlight-layer',
    data: contours,
    getPolygon: d => d,
    getFillColor: [150, 180, 220, 128],
    getLineColor: [0, 0, 0, 0],
    getLineWidth: lineWidth,
});
export const useHighlightLayer = (props) => {
    const [highlightedHexes, _setHighlightedHexes] = useState(Set());
    const contours = useMemo(() => [...highlightedHexes].map((hex) => Shape.getHexContour(hex)), [highlightedHexes]);
    const highlightLayerData = useMemo(() => createPolygonLayerData({ contours, lineWidth: getLineWidth(BASE_HIGHLIGHTED_LINE_WIDTH, props.zoom) }), [
        props.zoom,
        contours,
    ]);
    const setHighlightedHexes = (hexes) => _setHighlightedHexes(hexes);
    return { highlightLayerData, highlightedHexes, setHighlightedHexes };
};
//# sourceMappingURL=highlightLayer.js.map